export default __webpack_public_path__ + "static/media/element_32.4b56c983.jpg";